<template>
  <div>
    <ul class="file_list_con" v-if="listType == 'text'">
      <li v-for="file in value" :key="file.path" class="file_list_item">
        <span class="file_privew_name" @click="previewFile(file)">
          {{ file.name }}</span
        >
        <span @click="downloadFile(file)" class="file_download_icon"
          ><i class="el-icon-download"></i
        ></span>
      </li>
    </ul>
    <ul class="file_list_con file_img_list" v-else>
      <li v-for="file in value" :key="file.path" class="img_list_item">
        <img
          class="thub_img"
          :src="viewImageFile + file.path"
          @click="previewFile(file)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import file_mixin from "@tools/file_mixin.js";
import api from "@api";
export default {
  name: "FileList",
  mixins: [file_mixin],
  props: {
    value: {
      type: Array,
    },
    listType: {
      type: String,
      default: "text",
    },
  },
  data() {
    return {
      viewImageFile: api.viewImageFile,
    };
  },
};
</script>

<style lang="scss" scoped>
.file_list_con {
  padding-bottom: 12px;
  .thub_img {
    width: 100px;
    height: 100px;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #c0ccda;
  }
  .img_list_item {
    display: inline-block;
    margin-right: 18px;
  }
  .file_list_item {
    border-radius: 4px;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 12px;
    padding-right: 12px;
    &:hover {
      background-color: #efeff4;
    }
    color: #409eff;
    &:first-of-type {
      margin-top: -4px;
    }
  }
  .file_download_icon {
    margin-left: 18px;
    color: #808695;
    cursor: pointer;
    i {
      font-size: 18px;
    }
  }
  .file_privew_name {
    cursor: pointer;
  }
}
.file_img_list {
}
</style>